import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ContainerStationReducedFragmentDoc } from '../fragments/containerStationReduced.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchContainerStationsQueryVariables = Types.Exact<{
  search_term: Types.Scalars['String'];
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
}>;


export type SearchContainerStationsQuery = { __typename?: 'Query', searchContainerStationsPaginated: { __typename?: 'ContainerStationSearchPaginatedResponse', total: number, container_stations: Array<{ __typename?: 'ContainerStation', id: string, name: string, store_id: string, status?: Types.ContainerStationStatus | null, epc_tag: string, total_stock: number, item_location_name?: string | null, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null, archived: boolean, weight: number }, store: { __typename?: 'Store', id: string, name?: string | null, brand_id?: string | null }, current_item_location?: { __typename?: 'ContainerStationItemLocationInfo', name: string } | null, stock: Array<{ __typename?: 'ContainerStationStock', id: number, name: string, image_url?: string | null, sealed: boolean }> }> } };


export const SearchContainerStationsDocument = gql`
    query searchContainerStations($search_term: String!, $skip: Int!, $take: Int!) {
  searchContainerStationsPaginated(
    search_term: $search_term
    skip: $skip
    take: $take
  ) {
    total
    container_stations {
      ...ContainerStationReduced
    }
  }
}
    ${ContainerStationReducedFragmentDoc}`;

/**
 * __useSearchContainerStationsQuery__
 *
 * To run a query within a React component, call `useSearchContainerStationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContainerStationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContainerStationsQuery({
 *   variables: {
 *      search_term: // value for 'search_term'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useSearchContainerStationsQuery(baseOptions: Apollo.QueryHookOptions<SearchContainerStationsQuery, SearchContainerStationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContainerStationsQuery, SearchContainerStationsQueryVariables>(SearchContainerStationsDocument, options);
      }
export function useSearchContainerStationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContainerStationsQuery, SearchContainerStationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContainerStationsQuery, SearchContainerStationsQueryVariables>(SearchContainerStationsDocument, options);
        }
export type SearchContainerStationsQueryHookResult = ReturnType<typeof useSearchContainerStationsQuery>;
export type SearchContainerStationsLazyQueryHookResult = ReturnType<typeof useSearchContainerStationsLazyQuery>;
export type SearchContainerStationsQueryResult = Apollo.QueryResult<SearchContainerStationsQuery, SearchContainerStationsQueryVariables>;